import StrapiImage from "@/app/_components/StrapiImage";
import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import UpperCatalogBackground from "./UpperCatalogBackground";
import clsMerge from "@/app/util/clsMerge";
import {CatalogImageProps} from "@/app/_components/CourseShelf";

const UpperCatalogImage: FCWithHTMLAttributes<CatalogImageProps> = ({
	image,
	imageMd,
	imageLg,
	subject,
	className,
	imageClass,
	imageClassMd,
	imageClassLg,
}) => {
	return (
		<div
			className={clsMerge(
				"relative flex w-full overflow-hidden pt-[5.625rem] md:pt-16 xl:w-[18.3rem] xl:overflow-visible xl:pt-0",
				className
			)}
		>
			<UpperCatalogBackground subject={subject} />
			<div className="absolute bottom-0 left-2/4 h-auto w-max max-w-[90%] -translate-x-2/4 xl:bottom-[unset] xl:top-2/4 xl:flex xl:max-w-[150%] xl:-translate-y-2/4 xl:justify-center">
				<StrapiImage
					className={clsMerge("h-full w-[revert-layer] md:hidden", imageClass)}
					image={image}
				/>
				<StrapiImage
					className={clsMerge(
						"hidden h-auto w-[revert-layer] md:block xl:hidden",
						imageClassMd
					)}
					image={imageMd}
				/>
				<StrapiImage
					className={clsMerge(
						"hidden h-full w-[revert-layer] xl:block",
						imageClassLg
					)}
					image={imageLg}
				/>
			</div>
		</div>
	);
};

export default UpperCatalogImage;
